/**
 * The "On the call" banner's Join (decisions 142, 150; booking-contracts.md section 12). For a lesson it
 * reads "Join on This Computer" on a larger screen: the person is being rung on their phone, and joining
 * here stops that ring (stopRinging, before the call opens) and opens the lesson's call page. On a phone
 * it is not "this computer", and the long label crushed the banner's name at 390 (walk of 3 Nov): Join,
 * which stops the ring all the same. A call in the pair's room outside any lesson never rings: plain Join,
 * to the pair's room. A conversation's call opens over the screen.
 */
export function bannerJoin(c: { bookingId?: string | null; roomId: string }, wide = true): {
  label: string; stopRingFor: string | null; to: string | null;
} {
  if (c.bookingId) return { label: wide ? 'Join on This Computer' : 'Join', stopRingFor: c.bookingId, to: `/call/${c.bookingId}` };
  if (c.roomId.startsWith('room_')) return { label: 'Join', stopRingFor: null, to: `/room/${c.roomId}` };
  return { label: 'Join', stopRingFor: null, to: null };
}
